export enum ApiKeyStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  REVOKED = 'revoked',
}

export interface ApiKey {
  id?: string;
  partner_route: string;
  partner_name: string;
  key_hash: string;
  status: ApiKeyStatus;
  allowed_routes: string[];
  metadata?: Record<string, any>;
  expires_at?: Date;
  last_used_at?: Date;
  usage_count: number;
  revocation_reason?: string;
  created_at?: Date;
  updated_at?: Date;
}

export interface CreateAdminApiKeyDto {
  partner_route: string;
  partner_name: string;
  status?: ApiKeyStatus;
  allowed_routes: string[];
  metadata?: Record<string, any>;
  expires_at?: Date;
  revocation_reason?: string;
}

export interface UpdateAdminApiKeyDto {
  partner_route?: string;
  partner_name?: string;
  status?: ApiKeyStatus;
  allowed_routes?: string[];
  metadata?: Record<string, any>;
  expires_at?: Date;
  revocation_reason?: string;
}

export interface ApiKeyResponseDto extends ApiKey {
  // The actual API key value is only returned on creation
  api_key?: string;
}
